/* es5-ext/object/for-each */ function _(require, module, exports) {
    module.exports = require(325) /* ./_iterate */("forEach");
}
